



























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class VerticalStep extends Vue {
    @Prop() title!: string
    @Prop() subtitle!: string
    @Prop({ type: Boolean, default: false }) isCurrent!: string
    @Prop({ type: Boolean, default: false }) isCompleted!: string

    get componentClasses() {
        return {
            'vertical-step--current': this.isCurrent,
            'vertical-step--completed': this.isCompleted,
        }
    }
}
